<div class="address-display mat-card block-info">
    <ng-container *ngIf="!customerInfoWidget; else widget">
        <div class="mat-card-title">
            <button mat-button class="edit-block-button" type="button" color="primary" (click)="edit(address)">
                {{ address && address.id ? "Edit" : "Add" }}
            </button>
            <h2>{{ titleDescriptor }}</h2>
        </div>
        <dl *ngIf="address && address.id; else noAddress">
            <dt>Address</dt>
            <dd>{{ address.address || "&nbsp;" }}</dd>
            <dt>Address 2</dt>
            <dd>{{ address.address2 || "&nbsp;" }}</dd>
            <dt>City</dt>
            <dd>{{ address.city || "&nbsp;" }}</dd>
            <dt>State</dt>
            <dd>{{ address.state || "&nbsp;" }}</dd>
            <dt>Zip Code</dt>
            <dd>{{ address.zipcode || "&nbsp;" }}</dd>
            <dt>Building Type</dt>
            <dd>{{ address.buildingTypeName || "&nbsp;" }}</dd>
            <dt>Sq Ft / Sq M</dt>
            <dd>{{ address.area || "&nbsp;" }}</dd>
            <dt>Builder</dt>
            <dd>{{ address.builderName || "&nbsp;" }}</dd>
            <dt>Community</dt>
            <dd>{{ address.communityName || "&nbsp;" }}</dd>
            <dt>Gate Access Code</dt>
            <dd>{{ address.gateaccesscode || "&nbsp;" }}</dd>
            <dt>Cross Street</dt>
            <dd>{{ address.crossstreet || "&nbsp;" }}</dd>
            <div class="display-area-label">Directions</div>
            <dd class="display-area">
                <mat-form-field appearance="outline">
                    <textarea
                        matInput
                        id="directions"
                        [readonly]="true"
                        [(ngModel)]="address.directions"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="10"
                        cdkAutosizeMaxRows="20"
                    ></textarea>
                </mat-form-field>
            </dd>
        </dl>
    </ng-container>
</div>
<ng-template #widget>
    <dl class="redesign-dl" *ngIf="address && address.id; else noAddress">
        <div *ngIf="address.address" class="row">
            <dt class="term">Address</dt>
            <dd class="description">{{ address.address || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.address2" class="row">
            <dt class="term">Address 2</dt>
            <dd class="description">{{ address.address2 || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.city" class="row">
            <dt class="term">City</dt>
            <dd class="description">{{ address.city || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.state" class="row">
            <dt class="term">State</dt>
            <dd class="description">{{ address.state || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.zipcode" class="row">
            <dt class="term">Zip Code</dt>
            <dd class="description">{{ address.zipcode || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.buildingTypeName" class="row">
            <dt class="term">Building Type</dt>
            <dd class="description">{{ address.buildingTypeName || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.area" class="row">
            <dt class="term">Sq Ft / Sq M</dt>
            <dd class="description">{{ address.area || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.builderName" class="row">
            <dt class="term">Builder</dt>
            <dd class="description">{{ address.builderName || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.communityName" class="row">
            <dt class="term">Community</dt>
            <dd class="description">{{ address.communityName || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.gateaccesscode" class="row">
            <dt class="term">Gate Access Code</dt>
            <dd class="description">{{ address.gateaccesscode || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.crossstreet" class="row">
            <dt class="term">Cross Street</dt>
            <dd class="description">{{ address.crossstreet || "&nbsp;" }}</dd>
        </div>
        <div *ngIf="address.directions" class="row address-area">
            <dd class="description display-area">
                {{ address.directions || "&nbsp;" }}
            </dd>
            <dt class="term display-area-label">Directions</dt>
        </div>
    </dl>
</ng-template>

<ng-template #noAddress
    ><p class="no-address">No {{ titleDescriptor }}</p></ng-template
>
